import React from 'react';

import { Effects } from './@types/Models';
import { convertSpellNameToUpper } from './component/Intel/helpers/colHelpers';
import { svgStyles } from './Constants';
import { getColorFromTicks } from './helpers/ColorFormatting';
import { ReactComponent as AbolishRitualSVG } from './svgs/effects/abolishritual.svg';
import { ReactComponent as AggressionSVG } from './svgs/effects/aggression.svg';
import { ReactComponent as AmnesiaSVG } from './svgs/effects/amnesia.svg';
import { ReactComponent as AnimateDeadSVG } from './svgs/effects/animatedead.svg';
import { ReactComponent as AnonymitySVG } from './svgs/effects/anonymity.svg';
import { ReactComponent as ArsonSVG } from './svgs/effects/arson.svg';
import { ReactComponent as AssassinateWizardsSVG } from './svgs/effects/assassinatewizards.svg';
import { ReactComponent as BlizzardSVG } from './svgs/effects/blizzard.svg';
import { ReactComponent as BloodLustSVG } from './svgs/effects/bloodlust.svg';
import { ReactComponent as BribeGeneralsSVG } from './svgs/effects/bribegenerals.svg';
import { ReactComponent as BribeThievesSVG } from './svgs/effects/bribethieves.svg';
import { ReactComponent as BuildersBoonSVG } from './svgs/effects/buildersboon.svg';
import { ReactComponent as ChastitySVG } from './svgs/effects/chastity.svg';
import { ReactComponent as ClearSightSVG } from './svgs/effects/clearsight.svg';
import { ReactComponent as CrystalBallSVG } from './svgs/effects/crystalball.svg';
import { ReactComponent as CrystalEyeSVG } from './svgs/effects/crystaleye.svg';
import { ReactComponent as DestabiliseGuildsSVG } from './svgs/effects/destabilizeguilds.svg';
import { ReactComponent as DivineShieldSVG } from './svgs/effects/divineshield.svg';
import { ReactComponent as DroughtsSVG } from './svgs/effects/droughts.svg';
import { ReactComponent as ExplosionSVG } from './svgs/effects/explosions.svg';
import { ReactComponent as ExposeThievesSVG } from './svgs/effects/exposethieves.svg';
import { ReactComponent as FanaticismSVG } from './svgs/effects/fanaticism.svg';
import { ReactComponent as FertileLandsSVG } from './svgs/effects/fertilelands.svg';
import { ReactComponent as FireballSVG } from './svgs/effects/fireball.svg';
import { ReactComponent as FoolsGoldSVG } from './svgs/effects/foolsgold.svg';
import { ReactComponent as FountainOfKnowledgeSVG } from './svgs/effects/fountainofknowledge.svg';
import { ReactComponent as FreeprisonersSVG } from './svgs/effects/freeprisoners.svg';
import { ReactComponent as GhostWorkersSVG } from './svgs/effects/ghostworkers.svg';
import { ReactComponent as GluttonySVG } from './svgs/effects/gluttony.svg';
import { ReactComponent as GreaterArsonSVG } from './svgs/effects/greaterarson.svg';
import { ReactComponent as GreaterProtectionSVG } from './svgs/effects/greaterprotection.svg';
import { ReactComponent as GreedSVG } from './svgs/effects/greed.svg';
import { ReactComponent as GuileSVG } from './svgs/effects/guile.svg';
import { ReactComponent as HerosInpirationSVG } from './svgs/effects/herosinspiration.svg';
import { ReactComponent as IlluminateShadowsSVG } from './svgs/effects/illuminateshadows.svg';
import { ReactComponent as InciteRiotsSVG } from './svgs/effects/inciteriots.svg';
import { ReactComponent as InfiltrateSVG } from './svgs/effects/infiltrate.svg';
import { ReactComponent as InspireArmySVG } from './svgs/effects/inspirearmy.svg';
import { ReactComponent as InvisibilitySVG } from './svgs/effects/invisibility.svg';
import { ReactComponent as KidnapSVG } from './svgs/effects/kidnapping.svg';
import { ReactComponent as LandLustSVG } from './svgs/effects/landlust.svg';
import { ReactComponent as LightningStrikeSVG } from './svgs/effects/lightningstrike.svg';
import { ReactComponent as LoveAndPeaceSVG } from './svgs/effects/loveandpeace.svg';
import { ReactComponent as MagesFurySVG } from './svgs/effects/magesfury.svg';
import { ReactComponent as MagicShieldSVG } from './svgs/effects/magicshield.svg';
import { ReactComponent as MagicWardSVG } from './svgs/effects/magicward.svg';
import { ReactComponent as MeteorsSVG } from './svgs/effects/meteorshowers.svg';
import { ReactComponent as MindFocusSVG } from './svgs/effects/mindfocus.svg';
import { ReactComponent as MinersMystiqueSVG } from './svgs/effects/minersmystique.svg';
import { ReactComponent as MinorProtectionSVG } from './svgs/effects/minorprotection.svg';
import { ReactComponent as MistSVG } from './svgs/effects/mist.svg';
import { ReactComponent as MysticAuraSVG } from './svgs/effects/mysticaura.svg';
import { ReactComponent as MysticVortexSVG } from './svgs/effects/mysticvortex.svg';
import { ReactComponent as NaturesBlessingSVG } from './svgs/effects/naturesblessing.svg';
import { ReactComponent as NightmaresSVG } from './svgs/effects/nightmares.svg';
import { ReactComponent as NightStrikeSVG } from './svgs/effects/nightstrike.svg';
import { ReactComponent as ParadiseSVG } from './svgs/effects/paradise.svg';
import { ReactComponent as PatriotismSVG } from './svgs/effects/patriotism.svg';
import { ReactComponent as PitFallsSVG } from './svgs/effects/pitfalls.svg';
import { ReactComponent as PlagueSVG } from './svgs/effects/plague.svg';
import { ReactComponent as PropagandaSVG } from './svgs/effects/propaganda.svg';
import { ReactComponent as QuickFeetSVG } from './svgs/effects/quickfeet.svg';
import { ReactComponent as ReflectMagicSVG } from './svgs/effects/reflectmagic.svg';
import { ReactComponent as RevelationSVG } from './svgs/effects/revelation.svg';
import { ReactComponent as RobTheGranariesSVG } from './svgs/effects/robthegranaries.svg';
import { ReactComponent as RobTheTowersSVG } from './svgs/effects/robthetowers.svg';
import { ReactComponent as RobTheVaultsSVG } from './svgs/effects/robthevaults.svg';
import { ReactComponent as SabotageSVG } from './svgs/effects/sabotagewizards.svg';
import { ReactComponent as SalvationSVG } from './svgs/effects/salvation.svg';
import { ReactComponent as ScientificInsightSVG } from './svgs/effects/scientificinsights.svg';
import { ReactComponent as ShadowlightSVG } from './svgs/effects/shadowlight.svg';
import { ReactComponent as SlothSVG } from './svgs/effects/sloth.svg';
import { ReactComponent as SnatchNewsSVG } from './svgs/effects/snatchnews.svg';
import { ReactComponent as SpyOnDefenseSVG } from './svgs/effects/spyondefense.svg';
import { ReactComponent as SpyOnMilitarySVG } from './svgs/effects/spyonmilitary.svg';
import { ReactComponent as SpyOnSciencesSVG } from './svgs/effects/spyonsciences.svg';
import { ReactComponent as SpyOnThroneSVG } from './svgs/effects/spyonthrone.svg';
import { ReactComponent as StealWarHorsesSVG } from './svgs/effects/stealwarhorses.svg';
import { ReactComponent as StormsSVG } from './svgs/effects/storms.svg';
import { ReactComponent as SurveySVG } from './svgs/effects/survey.svg';
import { ReactComponent as TornadoesSVG } from './svgs/effects/tornadoes.svg';
import { ReactComponent as TownWatchSVG } from './svgs/effects/townwatch.svg';
import { ReactComponent as TreeOfGoldSVG } from './svgs/effects/treeofgold.svg';
import { ReactComponent as VerminSVG } from './svgs/effects/vermin.svg';
import { ReactComponent as WarSpoilsSVG } from './svgs/effects/warspoils.svg';
import { ReactComponent as WrathfulSmiteSVG } from './svgs/effects/wrathfulsmite.svg';

let style = {};
//https://www.svgrepo.com/

export const getEffect = (spellName: string, ticks: number) => {
  const hue = getColorFromTicks(ticks);
  style = { ...svgStyles, fill: hue };
  const spellLookUp = convertSpellNameToUpper(spellName);
  const svg = resolveSVG(spellLookUp, hue);
  return svg;
};
export const resolveSVG = (effectKey: string, hue?: string) => {
  let style = svgStyles;
  if (hue) {
    style = { ...svgStyles, fill: hue };
  }
  switch (effectKey) {
    case 'ABOLISHRITUAL':
      return <AbolishRitualSVG style={style} />;
    case 'AGGRESSION':
      return <AggressionSVG style={style} />;
    case 'AMNESIA':
      return <AmnesiaSVG style={style} />;
    case 'ANIMATEDEAD':
      return <AnimateDeadSVG style={style} />;
    case 'ANONYMITY':
      return <AnonymitySVG style={style} />;
    case 'ARSON':
      return <ArsonSVG style={style} />;
    case 'ASSASSINATEWIZARDS':
      return <AssassinateWizardsSVG style={style} />;
    case 'BLIZZARD':
      return <BlizzardSVG style={style} />;
    case 'BLOODLUST':
      return <BloodLustSVG style={style} />;
    case 'BRIBEGENERALS':
      return <BribeGeneralsSVG style={style} />;
    case 'BRIBETHIEVES':
      return <BribeThievesSVG style={style} />;
    case 'BUILDERSBOON':
      return <BuildersBoonSVG style={style} />;
    case 'CHASTITY':
      return <ChastitySVG style={style} />;
    case 'CLEARSIGHT':
      return <ClearSightSVG style={style} />;
    case 'CRYSTALBALL':
      return <CrystalBallSVG style={style} />;
    case 'CRYSTALEYE':
      return <CrystalEyeSVG style={style} />;
    case 'CUREPLAGUE':
      return <PlagueSVG style={style} />;
    case 'DESTABILIZEGUILDS':
      return <DestabiliseGuildsSVG style={style} />;
    case 'DESTROYRITUAL':
      return <AbolishRitualSVG style={style} />;
    case 'DIVINESHIELD':
      return <DivineShieldSVG style={style} />;
    case 'DROUGHT':
    case 'DROUGHTS':
      return <DroughtsSVG style={style} />;
    case 'EXPOSETHIEVES':
      return <ExposeThievesSVG style={style} />;
    case 'EXPLOSIONS':
      return <ExplosionSVG style={style} />;
    case 'FANATICISM':
      return <FanaticismSVG style={style} />;
    case 'FERTILELANDS':
      return <FertileLandsSVG style={style} />;
    case 'FIREBALL':
      return <FireballSVG style={style} />;
    case 'FOOLSGOLD':
      return <FoolsGoldSVG style={style} />;
    case 'FOUNTAINOFKNOWLEDGE':
      return <FountainOfKnowledgeSVG style={style} />;
    case 'FREEPRISONERS':
      return <FreeprisonersSVG style={style} />;
    case 'GHOSTWORKERS':
      return <GhostWorkersSVG style={style} />;
    case 'GREATERPROTECTION':
      return <GreaterProtectionSVG style={style} />;
    case 'GUILE':
      return <GuileSVG style={style} />;
    case 'GREED':
      return <GreedSVG style={style} />;
    case 'GREATERARSON':
      return <GreaterArsonSVG style={style} />;
    case 'GLUTTONY':
      return <GluttonySVG style={style} />;
    case 'HEROESINSPIRATION':
      return <HerosInpirationSVG style={style} />;
    case 'ILLUMINATESHADOWS':
      return <IlluminateShadowsSVG style={style} />;
    case 'INCITERIOTS':
    case 'RIOTS':
      return <InciteRiotsSVG style={style} />;
    case 'INFILTRATE':
      return <InfiltrateSVG style={style} />;
    case 'INSPIREARMY':
      return <InspireArmySVG style={style} />;
    case 'INVISIBILITY':
      return <InvisibilitySVG style={style} />;
    case 'KIDNAP':
      return <KidnapSVG style={style} />;
    case 'LANDLUST':
      return <LandLustSVG style={style} />;
    case 'LOVEANDPEACE':
      return <LoveAndPeaceSVG style={style} />;
    case 'LIGHTNINGSTRIKE':
      return <LightningStrikeSVG style={style} />;
    case 'MAGESFURY':
      return <MagesFurySVG style={style} />;
    case 'MAGICWARD':
      return <MagicWardSVG style={style} />;
    case 'MAGICSHIELD':
      return <MagicShieldSVG style={style} />;
    case 'METEORSHOWERS':
      return <MeteorsSVG style={style} />;
    case 'MINDFOCUS':
      return <MindFocusSVG style={style} />;
    case 'MINORPROTECTION':
      return <MinorProtectionSVG style={style} />;
    case 'MINERSMYSTIQUE':
      return <MinersMystiqueSVG style={style} />;
    case 'MIST':
      return <MistSVG style={style} />;
    case 'MYSTICAURA':
      return <MysticAuraSVG style={style} />;
    case 'MYSTICVORTEX':
      return <MysticVortexSVG style={style} />;
    case 'NATURESBLESSING':
      return <NaturesBlessingSVG style={style} />;
    case 'NIGHTMARE':
      return <NightmaresSVG style={style} />;
    case 'NIGHTSTRIKE':
      return <NightStrikeSVG style={style} />;
    case 'PARADISE':
      return <ParadiseSVG style={style} />;
    case 'PATRIOTISM':
      return <PatriotismSVG style={style} />;
    case 'PITFALLS':
      return <PitFallsSVG style={style} />;
    case 'PROPAGANDA':
      return <PropagandaSVG style={style} />;
    case 'QUICKFEET':
      return <QuickFeetSVG style={style} />;
    case 'ROBTHEGRANARIES':
      return <RobTheGranariesSVG style={style} />;
    case 'ROBTHEVAULTS':
      return <RobTheVaultsSVG style={style} />;
    case 'ROBTHETOWERS':
      return <RobTheTowersSVG style={style} />;
    case 'REFLECTMAGIC':
      return <ReflectMagicSVG style={style} />;
    case 'REVELATION':
      return <RevelationSVG style={style} />;
    case 'SABOTAGEWIZARDS':
      return <SabotageSVG style={style} />;
    case 'SALVATION':
      return <SalvationSVG style={style} />;
    case 'SCIENTIFICINSIGHT':
      return <ScientificInsightSVG style={style} />;
    case 'SHADOWLIGHT':
      return <ShadowlightSVG style={style} />;
    case 'SLOTH':
      return <SlothSVG style={style} />;
    case 'SNATCHNEWS':
      return <SnatchNewsSVG style={style} />;
    case 'SPYONDEFENSE':
      return <SpyOnDefenseSVG style={style} />;
    case 'SPYONTHRONE':
      return <SpyOnThroneSVG style={style} />;
    case 'SPYONMILITARY':
      return <SpyOnMilitarySVG style={style} />;
    case 'SPYONSCIENCES':
      return <SpyOnSciencesSVG style={style} />;
    case 'SURVEY':
      return <SurveySVG style={style} />;
    case 'STEALWARHORSES':
      return <StealWarHorsesSVG style={style} />;
    case 'STORMS':
      return <StormsSVG style={style} />;
    case 'TREEOFGOLD':
      return <TreeOfGoldSVG style={style} />;
    case 'TORNADOES':
      return <TornadoesSVG style={style} />;
    case 'TOWNWATCH':
      return <TownWatchSVG style={style} />;
    case 'VERMIN':
      return <VerminSVG style={style} />;
    case 'WARSPOILS':
      return <WarSpoilsSVG style={style} />;
    case 'WRATHFULSMITE':
    case 'WRATH':
      return <WrathfulSmiteSVG style={style} />;
    default:
      return null;
  }
};

export const effects: Effects = {
  ABOLISHRITUAL: {
    shortName: 'AR',
    displayName: 'Abolish Ritual',
    svg: resolveSVG('ABOLISHRITUAL'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: false,
  },
  AGGRESSION: {
    shortName: 'AGG',
    displayName: 'Aggression',
    svg: resolveSVG('AGGRESSION'),
    isBad: false,
    isDuration: true,
  },
  AMNESIA: {
    shortName: 'AMN',
    displayName: 'Amnesia',
    svg: resolveSVG('AMNESIA'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
  },
  ANIMATEDEAD: {
    shortName: 'AD',
    displayName: 'Animate Dead',
    svg: resolveSVG('ANIMATEDEAD'),
    isBad: false,
    isDuration: false,
  },
  ANONYMITY: {
    shortName: 'ANN',
    displayName: 'Anonymity',
    svg: resolveSVG('ANONYMITY'),
    isBad: false,
    isDuration: false,
  },
  ARSON: {
    shortName: 'ARS',
    displayName: 'Arson',
    svg: resolveSVG('ARSON'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  ASSASSINATEWIZARDS: {
    shortName: 'AW',
    displayName: 'Assassinate Wizards',
    svg: resolveSVG('ASSASSINATEWIZARDS'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  BLIZZARD: {
    shortName: 'BLI',
    displayName: 'Blizzard',
    svg: resolveSVG('BLIZZARD'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  BLOODLUST: {
    shortName: 'BL',
    displayName: 'Bloodlust',
    svg: resolveSVG('BLOODLUST'),
    isBad: true,
    isDuration: true,
  },
  BRIBEGENERALS: {
    shortName: 'BT',
    displayName: 'Bribe Generals',
    svg: resolveSVG('BRIBEGENERALS'),
    isBad: true,
    isDuration: true,
    isRequestable: false,
    isThievery: true,
  },
  BRIBETHIEVES: {
    shortName: 'BT',
    displayName: 'Bribe Thieves',
    svg: resolveSVG('BRIBETHIEVES'),
    isBad: true,
    isDuration: true,
    isRequestable: false,
    isThievery: true,
  },
  BUILDERSBOON: {
    shortName: 'BB',
    displayName: 'Builders Boon',
    svg: resolveSVG('BUILDERSBOON'),
    isBad: false,
    isDuration: true,
    isRequestable: false,
  },
  CHASTITY: {
    shortName: 'CHA',
    displayName: 'Chastity',
    svg: resolveSVG('CHASTITY'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  CLEARSIGHT: {
    shortName: 'CS',
    displayName: 'Clear Sight',
    svg: resolveSVG('CLEARSIGHT'),
    isBad: false,
    isDuration: true,
  },
  CRYSTALBALL: {
    shortName: 'CB',
    displayName: 'Crystal Ball',
    svg: resolveSVG('CRYSTALBALL'),
    isBad: true,
    isDuration: false,
  },
  CRYSTALEYE: {
    shortName: 'CE',
    displayName: 'Crystal Eye',
    svg: resolveSVG('CRYSTALEYE'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  CUREPLAGUE: {
    shortName: 'CPl',
    displayName: 'Cure Plague',
    svg: resolveSVG('CUREPLAGUE'),
    isBad: false,
    isDuration: true,
  },
  DESTABILIZEGUILDS: {
    shortName: 'DG',
    displayName: 'Destabilize Guilds',
    svg: resolveSVG('DESTABILIZEGUILDS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
    isThievery: true,
  },
  DESTROYRITUAL: {
    shortName: 'AR',
    displayName: 'Abolish Ritual',
    svg: resolveSVG('DESTROYRITUAL'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
  },
  DIVINESHIELD: {
    shortName: 'DS',
    displayName: 'Divine Shield',
    svg: resolveSVG('DIVINESHIELD'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  DROUGHT: {
    shortName: 'DR',
    displayName: 'Drought',
    svg: resolveSVG('DROUGHT'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  DROUGHTS: {
    shortName: 'DR',
    displayName: 'Drought',
    svg: resolveSVG('DROUGHTS'),
    isBad: true,
    isDuration: true,
    isRequestable: false,
  },
  EXPOSETHIEVES: {
    shortName: 'ET',
    displayName: 'Expose Thieves',
    svg: resolveSVG('EXPOSETHIEVES'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  EXPLOSIONS: {
    shortName: 'EX',
    displayName: 'Explosions',
    svg: resolveSVG('EXPLOSIONS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  FANATICISM: {
    shortName: 'FAN',
    displayName: 'Fanaticism',
    svg: resolveSVG('FANATICISM'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  FERTILELANDS: {
    shortName: 'FL',
    displayName: 'Fertile Lands',
    svg: resolveSVG('FERTILELANDS'),
    isBad: false,
    isDuration: true,
  },
  FIREBALL: {
    shortName: 'FB',
    displayName: 'Fireball',
    svg: resolveSVG('FIREBALL'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
  },
  FOOLSGOLD: {
    shortName: 'FG',
    displayName: 'Fools Gold',
    svg: resolveSVG('FOOLSGOLD'),
    isBad: true,
    isDuration: false,
  },
  FOUNTAINOFKNOWLEDGE: {
    shortName: 'FoK',
    displayName: 'Fountain of Knowledge',
    svg: resolveSVG('FOUNTAINOFKNOWLEDGE'),
    isBad: false,
    isDuration: true,
  },
  FREEPRISONERS: {
    shortName: 'FP',
    displayName: 'Free Prisoners',
    svg: resolveSVG('FREEPRISONERS'),
    isBad: true,
    isDuration: false,
  },
  GHOSTWORKERS: {
    shortName: 'GW',
    displayName: 'Ghost Workers',
    svg: resolveSVG('GHOSTWORKERS'),
    isBad: false,
    isDuration: true,
  },
  GLUTTONY: {
    shortName: 'GL',
    displayName: 'Gluttony',
    svg: resolveSVG('GLUTTONY'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  GREATERPROTECTION: {
    shortName: 'GP',
    displayName: 'Greater Protection',
    svg: resolveSVG('GREATERPROTECTION'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  GUILE: {
    shortName: 'GUI',
    displayName: 'Guile',
    svg: resolveSVG('GUILE'),
    isBad: true,
    isDuration: true,
  },
  GREED: {
    shortName: 'GR',
    displayName: 'Greed',
    svg: resolveSVG('GREED'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  GREATERARSON: {
    shortName: 'GA',
    displayName: 'Greater Arson',
    svg: resolveSVG('GREATERARSON'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  HEROESINSPIRATION: {
    shortName: 'HI',
    displayName: 'Heroes Inspiration',
    svg: resolveSVG('HEROESINSPIRATION'),
    isBad: false,
    isDuration: true,
  },
  PALADINSINSPIRATION: {
    shortName: 'HI',
    displayName: 'Heroes Inspiration',
    svg: resolveSVG('HEROESINSPIRATION'),
    isBad: false,
    isDuration: true,
  },
  ILLUMINATESHADOWS: {
    shortName: 'IS',
    displayName: 'Illuminate Shadows',
    svg: resolveSVG('ILLUMINATESHADOWS'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  INCITERIOTS: {
    shortName: 'IR',
    displayName: 'Incite Riots',
    svg: resolveSVG('INCITERIOTS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
    isThievery: true,
  },
  RIOTS: {
    shortName: 'IR',
    displayName: 'Incite Riots',
    svg: resolveSVG('RIOTS'),
    isBad: true,
    isDuration: true,
    isRequestable: false,
    isThievery: true,
  },
  INFILTRATE: {
    shortName: 'INF',
    displayName: "Infiltrate Thieves' Guild",
    svg: resolveSVG('INFILTRATE'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  INSPIREARMY: {
    shortName: 'IA',
    displayName: 'Inspire Army',
    svg: resolveSVG('INSPIREARMY'),
    isBad: false,
    isDuration: true,
  },
  INVISIBILITY: {
    shortName: 'INV',
    displayName: 'Invisibility',
    svg: resolveSVG('INVISIBILITY'),
    isBad: false,
    isDuration: true,
  },
  KIDNAP: {
    shortName: 'KN',
    displayName: 'Kidnap',
    svg: resolveSVG('KIDNAP'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  LANDLUST: {
    shortName: 'LL',
    displayName: 'Land Lust',
    svg: resolveSVG('LANDLUST'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
  },
  LOVEANDPEACE: {
    shortName: 'LP',
    displayName: 'Love and Peace',
    svg: resolveSVG('LOVEANDPEACE'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  LIGHTNINGSTRIKE: {
    shortName: 'LS',
    displayName: 'Lightning Strike',
    svg: resolveSVG('LIGHTNINGSTRIKE'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
  },
  MAGESFURY: {
    shortName: 'MFU',
    displayName: "Mage's Fury",
    svg: resolveSVG('MAGESFURY'),
    isBad: false,
    isDuration: true,
  },
  MAGICWARD: {
    shortName: 'MW',
    displayName: 'Magic Ward',
    svg: resolveSVG('MAGICWARD'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  MAGICSHIELD: {
    shortName: 'MSH',
    displayName: 'Magic Shield',
    svg: resolveSVG('MAGICSHIELD'),
    isBad: false,
    isDuration: true,
  },
  METEORSHOWERS: {
    shortName: 'MS',
    displayName: 'Meteor Showers',
    svg: resolveSVG('METEORSHOWERS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  MINDFOCUS: {
    shortName: 'MFO',
    displayName: 'Mind Focus',
    svg: resolveSVG('MINDFOCUS'),
    isBad: false,
    isDuration: true,
  },
  MINORPROTECTION: {
    shortName: 'MP',
    displayName: 'Minor Protection',
    svg: resolveSVG('MINORPROTECTION'),
    isBad: false,
    isDuration: true,
    isRequestable: false,
  },
  MINERSMYSTIQUE: {
    shortName: 'MM',
    displayName: "Miner's Mystique",
    svg: resolveSVG('MINERSMYSTIQUE'),
    isBad: false,
    isDuration: true,
  },
  MIST: {
    shortName: 'MI',
    displayName: 'Mist',
    svg: resolveSVG('MIST'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  MYSTICAURA: {
    shortName: 'MA',
    displayName: 'Mystic Aura',
    svg: resolveSVG('MYSTICAURA'),
    isBad: false,
    isDuration: true,
  },
  MYSTICVORTEX: {
    shortName: 'MV',
    displayName: 'Mystic Vortex',
    svg: resolveSVG('MYSTICVORTEX'),
    isBad: true,
    isDuration: false,
  },
  NATURESBLESSING: {
    shortName: 'NB',
    displayName: "Nature's Blessing",
    svg: resolveSVG('NATURESBLESSING'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  NIGHTMARE: {
    shortName: 'NM',
    displayName: 'Nightmare',
    svg: resolveSVG('NIGHTMARE'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
  },
  NIGHTSTRIKE: {
    shortName: 'NS',
    displayName: 'Night Strike',
    svg: resolveSVG('NIGHTSTRIKE'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  PARADISE: {
    shortName: 'DICE',
    displayName: 'Paradise',
    svg: resolveSVG('PARADISE'),
    isBad: false,
    isDuration: false,
    isRequestable: false,
  },
  PATRIOTISM: {
    shortName: 'PAT',
    displayName: 'Patriotism',
    svg: resolveSVG('PATRIOTISM'),
    isBad: false,
    isDuration: true,
    isRequestable: true,
  },
  PITFALLS: {
    shortName: 'PF',
    displayName: 'Pitfalls',
    svg: resolveSVG('PITFALLS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  PROPAGANDA: {
    shortName: 'PROP',
    displayName: 'Propaganda',
    svg: resolveSVG('PROPAGANDA'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  QUICKFEET: {
    shortName: 'QF',
    displayName: 'Quick Feet',
    svg: resolveSVG('QUICKFEET'),
    isBad: false,
    isDuration: true,
  },
  ROBTHEGRANARIES: {
    shortName: 'RG',
    displayName: 'Rob the Granaries',
    svg: resolveSVG('ROBTHEGRANARIES'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  ROBTHEVAULTS: {
    shortName: 'RV',
    displayName: 'Rob the Vaults',
    svg: resolveSVG('ROBTHEVAULTS'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  ROBTHETOWERS: {
    shortName: 'RT',
    displayName: 'Rob the Towers',
    svg: resolveSVG('ROBTHETOWERS'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  REFLECTMAGIC: {
    shortName: 'RM',
    displayName: 'Reflect Magic',
    svg: resolveSVG('REFLECTMAGIC'),
    isBad: false,
    isDuration: true,
  },
  REVELATION: {
    shortName: 'REV',
    displayName: 'Revelation',
    svg: resolveSVG('REVELATION'),
    isBad: false,
    isDuration: true,
  },
  SABOTAGEWIZARDS: {
    shortName: 'SW',
    displayName: 'Sabotage Wizards',
    svg: resolveSVG('SABOTAGEWIZARDS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
    isThievery: true,
  },
  SALVATION: {
    shortName: 'SAL',
    displayName: 'Salvation',
    svg: resolveSVG('SALVATION'),
    isBad: false,
    isDuration: true,
  },
  SCIENTIFICINSIGHT: {
    shortName: 'SI',
    displayName: 'Scientific Insight',
    svg: resolveSVG('SCIENTIFICINSIGHT'),
    isBad: false,
    isDuration: true,
  },
  SHADOWLIGHT: {
    shortName: 'ShL',
    displayName: 'Shadow Light',
    svg: resolveSVG('SHADOWLIGHT'),
    isBad: false,
    isDuration: false,
  },
  SLOTH: {
    shortName: 'Slo',
    displayName: 'Sloth',
    svg: resolveSVG('SLOTH'),
    isBad: true,
    isDuration: true,
    isRequestable: false,
  },
  SNATCHNEWS: {
    shortName: 'SN',
    displayName: 'Snatch News',
    svg: resolveSVG('SNATCHNEWS'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  SOULBLIGHT: {
    shortName: 'SB',
    displayName: 'Soul Blight',
    svg: resolveSVG('SPYONDEFENSE'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: false,
  },
  SPYONDEFENSE: {
    shortName: 'SOD',
    displayName: 'Spy on Defense',
    svg: resolveSVG('SPYONDEFENSE'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  SPYONTHRONE: {
    shortName: 'SOT',
    displayName: 'Spy on Throne',
    svg: resolveSVG('SPYONTHRONE'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  SPYONMILITARY: {
    shortName: 'SOM',
    displayName: 'Spy on Military',
    svg: resolveSVG('SPYONMILITARY'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  SPYONSCIENCES: {
    shortName: 'SOS',
    displayName: 'Spy on Sciences',
    svg: resolveSVG('SPYONSCIENCES'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  SURVEY: {
    shortName: 'SUR',
    displayName: 'Survey',
    svg: resolveSVG('SURVEY'),
    isBad: true,
    isDuration: false,
    isRequestable: false,
    isThievery: true,
  },
  STEALWARHORSES: {
    shortName: 'SWH',
    displayName: 'Steal War Horses',
    svg: resolveSVG('STEALWARHORSES'),
    isBad: true,
    isDuration: false,
    isRequestable: true,
    isThievery: true,
  },
  STORMS: {
    shortName: 'Sto',
    displayName: 'Storms',
    svg: resolveSVG('STORMS'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  TREEOFGOLD: {
    shortName: 'ToG',
    displayName: 'Tree of Gold',
    svg: resolveSVG('TREEOFGOLD'),
    isBad: false,
    isDuration: false,
  },
  TORNADOES: {
    shortName: 'TOR',
    displayName: 'Tornadoes',
    svg: resolveSVG('TORNADOES'),
    isBad: false,
    isDuration: true,
  },
  TOWNWATCH: {
    shortName: 'TW',
    displayName: 'Town Watch',
    svg: resolveSVG('TOWNWATCH'),
    isBad: false,
    isDuration: true,
  },
  VERMIN: {
    shortName: 'VER',
    displayName: 'Vermin',
    svg: resolveSVG('VERMIN'),
    isBad: true,
    isDuration: false,
  },
  WARSPOILS: {
    shortName: 'WSp',
    displayName: 'War Spoils',
    svg: resolveSVG('WARSPOILS'),
    isBad: false,
    isDuration: true,
  },
  WRATHFULSMITE: {
    shortName: 'Wra',
    displayName: 'Wrath',
    svg: resolveSVG('WRATHFULSMITE'),
    isBad: true,
    isDuration: true,
    isRequestable: true,
  },
  WRATH: {
    shortName: 'Wra',
    displayName: 'Wrath',
    svg: resolveSVG('WRATH'),
    isBad: true,
    isDuration: true,
    isRequestable: false,
  },
};
